import navigationMenuMain from './components/navigationMenu';
import initGoogleMap from './components/googlemapFilter';
import Scrollesel from './components/scrollesel';
import widgetFormSubmit from './components/widgetFormSubmit';
import eventFormSubmit from './components/eventFormSubmit';
import homepageMain from './pages/homepage';
import eventspageMain from './pages/eventspage';
import countriespageMain from './pages/countriesfilter';
import countriesmarginMain from './pages/countriesmargin';
import propertyinnerMain from './pages/propertyinner';
import contactMain from './pages/contact';
import stickybits from 'stickybits';
import MicroModal from 'micromodal';
import contactModalMain from "./vendors/contact-modal";


MicroModal.init();
stickybits('.stickyheader', { useStickyClasses: true, stickyClass: 'shadow' });
navigationMenuMain();

if (document.querySelector('.page[data-page="home"]')) {
  homepageMain();
}

if (document.querySelector('.page[data-page="events"]') || document.querySelector('.page[data-page="news"]')) {
  eventspageMain();
}

if (document.querySelector('.page[data-page="event-article"]')) {
  eventFormSubmit();
}

if (document.querySelector('.page[data-page="profile"]')) {
  const scrollesel = new Scrollesel();
}

if (document.querySelector('.page[data-page="countries"]')) {
  contactModalMain();
  countriespageMain();
  countriesmarginMain();
  window.addEventListener('resize', function(event) {
    countriesmarginMain();
  });
}

if (document.querySelector('.page[data-page="property-inner"]')) {
  contactModalMain();
  propertyinnerMain();
  // Load and initialize the page. 
  if ( document.querySelector('#map_canvas') != null ) {
    google.maps.event.addDomListener(window, 'load', initGoogleMap);
  }
}

if (document.querySelector('.page[data-page="contact-us"]')) {
  contactMain();
}

if (document.querySelector('.post')) {
  document.querySelector('.post').classList.add('container');
  document.querySelector('.post-header').classList.add('col-12');
}

$(document).ready(function() {
  $('#headerVideoLink').magnificPopup({
    type:'inline',
    midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });
  
  widgetFormSubmit();
});

// VIDEO 2
$('.ytvideo[data-video]').one('click', function() {

  var $this = $(this);
  var width = $this.attr("width");
  var height = $this.attr("height");
  
  // $this.html('<iframe src="https://www.youtube.com/embed/' + $this.data("video") + '?autoplay=1" allow="autoplay"></iframe>');
  $('.ytvideo').css('background-image','none');
  // $this.html('<video controls autoplay><source src="../img/video/verdo.mp4" type="video/mp4">Your browser does not support the video tag.</video>');
  $this.html('<iframe src="https://www.youtube.com/embed/' + $this.data("video") + '?autoplay=1" allow="autoplay"></iframe>');
});
